module.exports = __webpack_public_path__ + "img/banner-loja.f412cb31.jpeg";